import Content from './content';
import { Theme } from '@/theme';
import { useTranslation } from '@CS/hooks';
import { Loader as Assets } from '@CS/assets';
import Spinner from '@CS/assets/loader.svg?component';
import LottieAnimation from '@CS/components/LottieAnimation';
import { LoaderStyle, ImageStyle, SpinnerStyle } from './Loader.styles';

export type LoaderProps = {
  overlay?: boolean;
  opacity?: number;
  image?: boolean;
  color?: string;
  speed?: number;
  width?: number;
  lottie?: JSON;
};

export const Loader = ({
  color = Theme.color.white,
  overlay = false,
  opacity = 0.5,
  speed = 2.5,
  width = 50,
  lottie,
  image
}: LoaderProps) => {
  const logo = useTranslation(Content);

  const loader = lottie ? (
    <ImageStyle>
      <LottieAnimation animationData={Assets.lottie} />
    </ImageStyle>
  ) : image ? (
    <ImageStyle color={color} speed={speed} width={width}>
      <img alt="Golden Getaway" src={logo} />
      <div><Spinner /></div>
    </ImageStyle>
  ) : (
    <SpinnerStyle color={color} speed={speed} width={width}>
      <Spinner />
    </SpinnerStyle>
  );

  return (
    <LoaderStyle $overlay={overlay} opacity={opacity}>
      {loader}
    </LoaderStyle>
  );
};
